import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const PrintFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M8.00946 5.84649H12.1617V9.45196H15.7672V12.3637H17.1683V8.42669L13.187 4.44531H6.60828V12.3637H8.00946V5.84649ZM4.36633 13.5964V19.5551H19.6336V13.5964H4.36633ZM18.1936 18.1151H5.80634V15.0364H18.1936L18.1936 18.1151Z" />
      <path d="M18.1936 18.1151H5.80634V15.0364H18.1936L18.1936 18.1151Z" />
    </SvgIcon>
  );
});
